import { get, post } from "@/lib/fetcher";

export const getClientBoldSignDocuments = async (venueId) => {
  return await get(`/admin/venues/${venueId}/client_bold_sign_documents`);
};

export const generateBoldSignDocumentFromTemplate = async (venueId, templateId) => {
  return await post(`/admin/venues/${venueId}/client_bold_sign_documents/generate_from_template`, {
    template_id: templateId
  });
};

export const syncBoldSignDocumentStatus = async (venueId, documentId) => {
  // Custom fetch since our route uses member route pattern
  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://ramsden-admin.fly.dev/api/v1";

  function getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
  }

  const url = `${API_BASE_URL}/admin/venues/${venueId}/client_bold_sign_documents/${documentId}/sync_status`;

  const headers = {
    "Content-Type": "application/json",
    "X-CSRF-Token": getCsrfToken()
  };

  const response = await fetch(url, {
    method: "PATCH",
    headers,
    credentials: "include"
  });

  if (!response.ok) {
    throw new Error(`PATCH sync_status failed with status ${response.status}`);
  }

  return await response.json();
};

export const syncAllBoldSignDocumentStatuses = async (venueId) => {
  // Custom fetch since our route uses collection route pattern
  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://ramsden-admin.fly.dev/api/v1";

  function getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
  }

  const url = `${API_BASE_URL}/admin/venues/${venueId}/client_bold_sign_documents/sync_all_statuses`;

  const headers = {
    "Content-Type": "application/json",
    "X-CSRF-Token": getCsrfToken()
  };

  const response = await fetch(url, {
    method: "PATCH",
    headers,
    credentials: "include"
  });

  if (!response.ok) {
    throw new Error(`PATCH sync_all_statuses failed with status ${response.status}`);
  }

  return await response.json();
};

export const generateClientSigningLink = async (venueId, documentRecordId) => {
  return await post(`/admin/venues/${venueId}/client_bold_sign_documents/${documentRecordId}/generate_signing_link`);
};

export const generateRamsdenSigningLink = async (venueId, documentRecordId) => {
  return await post(`/admin/venues/${venueId}/client_bold_sign_documents/${documentRecordId}/generate_ramsden_signing_link`);
};

export const generateBothSigningLinks = async (venueId, documentRecordId) => {
  return await post(`/admin/venues/${venueId}/client_bold_sign_documents/${documentRecordId}/generate_both_signing_links`);
};
